(() => {
const cursor=document.getElementById('sc-edhardy-cursor');
if(!cursor||cursor.dataset.initialized)return;
cursor.dataset.initialized='true';
const image=cursor.querySelector('img'),root=document.documentElement;
const fine=matchMedia('(hover:hover) and (pointer:fine)');
const reduced=matchMedia('(prefers-reduced-motion:reduce)');
const anchors=[[.40,.23],[.57,.20],[.30,.37],[.67,.36],[.42,.46],[.60,.49],[.48,.64],[.51,.77]];
let loaded=image.complete&&image.naturalWidth>0;
function hide(){cursor.classList.remove('is-visible');root.classList.remove('sc-tiger-cursor-active');}
function place(s){const a=anchors[Math.floor(Math.random()*anchors.length)],w=parseFloat(s.style.width),h=parseFloat(s.style.height);s.style.left=((a[0]+(Math.random()-.5)*.06)*100-w/2)+'%';s.style.top=((a[1]+(Math.random()-.5)*.06)*100-h/2)+'%';}
if(cursor.classList.contains('sc-tiger-cursor--shimmer')){
for(let i=0;i<8;i++){const s=document.createElement('i'),size=18+Math.random()*10;s.style.width=size+'%';s.style.height=size*1.095+'%';place(s);s.style.animationDuration=(2.6+Math.random()*2).toFixed(2)+'s';s.style.animationDelay=(-Math.random()*4.6).toFixed(2)+'s';s.addEventListener('animationiteration',()=>place(s));cursor.appendChild(s);}
}
image.addEventListener('load',()=>{loaded=true;});
image.addEventListener('error',()=>{loaded=false;hide();});
document.addEventListener('pointermove',e=>{
const target=e.target;
if(!loaded||!fine.matches||e.pointerType!=='mouse'||!(target instanceof Element)||target.closest('input,select,textarea,[contenteditable]:not([contenteditable="false"])')){hide();return;}
cursor.style.transform='translate3d('+(e.clientX-2)+'px,'+(e.clientY-2)+'px,0)';
cursor.classList.add('is-visible');root.classList.add('sc-tiger-cursor-active');
},{passive:true});
document.addEventListener('pointerout',e=>{if(!e.relatedTarget)hide();});
document.addEventListener('scroll',hide,{passive:true,capture:true});
document.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse')hide();},{passive:true});
document.addEventListener('keydown',hide);
document.addEventListener('visibilitychange',hide);
window.addEventListener('blur',hide);window.addEventListener('pagehide',hide);
fine.addEventListener('change',hide);reduced.addEventListener('change',hide);
})();